import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { deepOrange } from "@material-ui/core/colors";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    messageRow: {
      display: "flex",
      gap: 2,
      alignItems: "flex-start",
    },
    messageRowRight: {
      display: "flex",
      justifyContent: "flex-end",
      alignSelf: "flex-end",
      maxWidth: "max-content",
    },
    messageBlue: {
      position: "relative",
      marginLeft: "20px",
      marginBottom: "10px",
      padding: "10px",
      backgroundColor: "#A8DDFD",
      width: "100%",
      textAlign: "left",
      border: "1px solid #97C6E3",
      borderRadius: "10px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid #A8DDFD",
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        left: "-15px",
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid #97C6E3",
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        left: "-17px",
      },
    },
    messageOrange: {
      position: "relative",
      marginRight: "20px",
      marginBottom: "10px",
      padding: "10px",
      backgroundColor: "#f8e896",
      width: "100%",
      maxWidth: "30em",
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid #dfd087",
      borderRadius: "10px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid #f8e896",
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        right: "-15px",
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid #dfd087",
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        right: "-17px",
      },
    },

    messageContent: {
      padding: 0,
      margin: 0,
    },
    messageTimeStampRight: {
      fontSize: ".85em",
      fontWeight: "300",
      paddingTop: "5px",
      bottom: "-3px",
      left: "5px",
      display: "flex",
      alignItems: "center",
      gap: 4,
    },

    orange: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    avatarNothing: {
      color: "transparent",
      backgroundColor: "transparent",
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    displayName: {
      marginLeft: "20px",
    },
  })
);

export const MessageLeft = (props) => {
  const message = props.message ? props.message : "no message";
  const timestamp = props.timestamp ? props.timestamp : "";
  const deliveryType = props.deliveryType; // New prop for delivery type
  const classes = useStyles();
  return (
    <>
      <div className={classes.messageRow}>
        <Avatar
          alt={"EH"}
          className={classes.orange}
          src={require("../../assets/img/withoutNameEng.png")}
        ></Avatar>
        <div>
          <div className={classes.displayName}></div>
          <div className={classes.messageBlue}>
            <div>
              <Typography variant="body2">{message}</Typography>
            </div>
            <div className={classes.messageTimeStampRight}>
              {renderDeliveryStatus(deliveryType)}
              <time>{timestamp}</time>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const MessageRight = (props) => {
  const classes = useStyles();
  const message = props.message ? props.message : "no message";
  const timestamp = props.timestamp ? props.timestamp : "";
  const deliveryType = props.deliveryType; // New prop for delivery type
  return (
    <div className={classes.messageRowRight}>
      <div className={classes.messageOrange}>
        <Typography variant="body2">{message}</Typography>
        <div className={classes.messageTimeStampRight}>
          {renderDeliveryStatus(deliveryType)}
          <time>{timestamp}</time>
        </div>
      </div>
    </div>
  );
};

const renderDeliveryStatus = (deliveryType) => {
  if (deliveryType === "seen") {
    return <i style={{ fontSize: 12 }} className="fa fa-check-circle" />;
  } else if (deliveryType === "delivered") {
    return <i style={{ fontSize: 12 }} className="fa fa-check-double" />;
  } else {
    return <i style={{ fontSize: 12 }} className="fa fa-check" />;
  }
};
